import { render, staticRenderFns } from "./InJourneyAccordionSummary.vue?vue&type=template&id=ce90453c&scoped=true"
import script from "./InJourneyAccordionSummary.vue?vue&type=script&lang=js"
export * from "./InJourneyAccordionSummary.vue?vue&type=script&lang=js"
import style0 from "./InJourneyAccordionSummary.vue?vue&type=style&index=0&id=ce90453c&prod&lang=scss&scoped=true"
import style1 from "./InJourneyAccordionSummary.vue?vue&type=style&index=1&id=ce90453c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce90453c",
  null
  
)

export default component.exports